import { useState, useEffect, useCallback } from 'react';
import * as logger from '../../logger';

export function useUserMedia(
  requestedMedia: MediaStreamConstraints,
): [MediaStream | null, () => Promise<void>, boolean] {
  const [mediaStream, setMediaStream] = useState<MediaStream | null>(null);
  const [mediaStreamLoading, setMediaStreamLoading] = useState(true);

  const enableStream = useCallback(async () => {
    setMediaStreamLoading(true);
    try {
      const stream = await navigator.mediaDevices.getUserMedia(requestedMedia);
      setMediaStream(stream);
    } catch (err) {
      logger.error(err);
    }
    setMediaStreamLoading(false);
  }, [requestedMedia]);

  useEffect(() => {
    if (!mediaStream) {
      enableStream();
    } else {
      return function cleanup() {
        mediaStream.getTracks().forEach((track) => {
          track.stop();
        });
      };
    }
  }, [enableStream, mediaStream]);

  return [mediaStream, enableStream, mediaStreamLoading];
}
